/**
 * CommunityStats — Shows community engagement metrics
 */
import React from 'react';
import { Users, Camera, Heart, Bookmark, TrendingUp, MessageSquare } from 'lucide-react';

export function CommunityStats({
  restaurant,
  language = 'th',
  className = ''
}) {
  const stats = [
    {
      icon: <MessageSquare size={20} />,
      label: language === 'th' ? 'รีวิว' : 'Reviews',
      value: restaurant.reviewCount || 0,
      trend: restaurant.reviewTrend || null
    },
    {
      icon: <Camera size={20} />,
      label: language === 'th' ? 'รูปภาพ' : 'Photos',
      value: restaurant.photoCount || 0,
      trend: restaurant.photoTrend || null
    },
    {
      icon: <Heart size={20} />,
      label: language === 'th' ? 'ถูกใจ' : 'Favorites',
      value: restaurant.favoriteCount || 0,
      trend: null
    },
    {
      icon: <Bookmark size={20} />,
      label: language === 'th' ? 'อยากไป' : 'Want to Visit',
      value: restaurant.bookmarkCount || 0,
      trend: null
    }
  ];

  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 gap-4 ${className}`}>
      {stats.map((stat, index) => (
        <div
          key={index}
          className="stat-card group"
        >
          <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-neutral-100 text-neutral-500 group-hover:bg-brand-50 group-hover:text-brand-500 transition-colors mb-3">
            {stat.icon}
          </div>
          <div className="value animate-count-up">
            {stat.value >= 1000
              ? `${(stat.value / 1000).toFixed(1)}k`
              : stat.value.toLocaleString()
            }
          </div>
          <div className="label">{stat.label}</div>
          {stat.trend && (
            <div className="trend flex items-center gap-1">
              <TrendingUp size={12} />
              {stat.trend}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/**
 * CommunityActivity — Recent community activity feed
 */
export function CommunityActivity({
  activities = [],
  language = 'th',
  className = ''
}) {
  if (activities.length === 0) return null;

  return (
    <div className={`space-y-3 ${className}`}>
      {activities.slice(0, 5).map((activity, index) => (
        <div
          key={index}
          className="flex items-center gap-3 p-3 bg-neutral-50 rounded-xl"
        >
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center text-white text-[12px] font-medium"
            style={{ backgroundColor: activity.userColor || '#B8860B' }}
          >
            {activity.userName.charAt(0)}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[13px] text-neutral-700 truncate">
              <span className="font-medium">{activity.userName}</span>
              {' '}
              {activity.action}
            </p>
            <span className="text-[11px] text-neutral-400">
              {activity.time}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CommunityStats;
